import { render, staticRenderFns } from "./StudioPlaylistMediaTag.vue?vue&type=template&id=4f4689bc&scoped=true&"
import script from "./StudioPlaylistMediaTag.vue?vue&type=script&lang=ts&"
export * from "./StudioPlaylistMediaTag.vue?vue&type=script&lang=ts&"
import style0 from "./StudioPlaylistMediaTag.vue?vue&type=style&index=0&id=4f4689bc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f4689bc",
  null
  
)

export default component.exports